// extracted by mini-css-extract-plugin
export default {"button":"i4Ftz7ifq8fsvTBYJbrp"};